import React from 'react'

function RamtechLogoSvg() {
  return (
    <svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="164" height="164" fill="#D9D9D9"/>
        <rect width="41" height="41" fill="#016738"/>
        <rect y="41" width="41" height="41" fill="#00BAB9"/>
        <rect y="82" width="41" height="41" fill="#2BAAE1"/>
        <rect y="123" width="41" height="41" fill="#0370BB"/>
        <rect x="41" y="123" width="41" height="41" fill="#858585"/>
        <rect x="82" y="123" width="41" height="41" fill="#858585"/>
        <rect x="123" y="123" width="41" height="41" fill="#F55C23"/>
        <rect x="123" y="82" width="41" height="41" fill="#ED1B24"/>
        <rect x="82" y="82" width="41" height="41" fill="#F8A434"/>
        <rect x="41" y="82" width="41" height="41" fill="#038839"/>
        <rect x="41" y="41" width="41" height="41" fill="#3DB64F"/>
        <rect x="82" y="41" width="41" height="41" fill="#D8E020"/>
        <rect x="123" y="41" width="41" height="41" fill="#C3272B"/>
        <rect x="123" width="41" height="41" fill="#662E91"/>
        <rect x="82" width="41" height="41" fill="#FBEF1D"/>
        <rect x="41" width="41" height="41" fill="#8AC742"/>
        <path d="M82.1327 28L164 164H0L82.1327 28Z" fill="white"/>
        <path d="M163.867 164L82 28V164H163.867Z" fill="url(#paint0_linear_0_1)"/>
        <defs>
        <linearGradient id="paint0_linear_0_1" x1="122.934" y1="28" x2="122.934" y2="164" gradientUnits="userSpaceOnUse">
        <stop stop-color="#898CA0"/>
        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0"/>
        </linearGradient>
        </defs>
    </svg>
  )
}

export default RamtechLogoSvg